module.exports = __webpack_public_path__ + "static/icons/icon-car-hire-8464094b86743755e8d61ec8820769b6.svg";